// export all selectors at once to make imports easier
import queryString from "data/queryString";
import { Location } from "history";
import { isSpecialFolderItemUri } from "data/utils";
export {
    favoritesStatusSelector,
    favoritesFavoritesSelector,
} from "./favoritesReducer";
export {
    userIdSelector,
    userNameSelector,
    userStatusSelector,
    userCorrelationIdSelector,
    userSitesSelector,
    userMainNavigationSelector,
    userLanguageSelector,
    userDecimalSeparator,
    userThousandSeparator,
    userItemActionsSelector,
    userFormActionsSelector,
    userHasOfflineItemsSelector,
    userIsWfEnabledSelector,
    userTopbarItemsSelector,
    userIsAdminSelector,
} from "./userReducer";
export {
    loginStatusSelector,
    loginIdTokenSelector,
    loginAccessTokenSelector,
    loginRefreshTokenSelector,
    loginExpiresOnSelector,
    loginExpiresInSelector,
} from "./loginReducer";
export {
    treeStatusSelector,
    treeErrorSelector,
    treeNodesSelector,
    treeIsRootSelector,
    treeIsBrowsableSelector,
    treeTotalCountSelector,
    treeNextPageSelector,
    treePrevPageSelector,
} from "./treeReducer";
export {
    docsItemUriSelector,
    docsStatusSelector,
    docsPageNumSelector,
    docsErrorSelector,
    docsColsSelector,
    docsRowsSelector,
    docsActiveRowItemUriSelector,
    docsTotalCountSelector,
    docsFiltersSelector,
    docsSortsSelector,
    docsFilterTextSelector,
} from "./docsReducer";
export {
    thumbnailStatusSelector,
    thumbnailResultSelector,
} from "./thumbnailsReducer";
export {
    docsLayoutSelector,
    docsLayoutStatusSelector,
    docsLayoutFiltersSelector,
    docsLayoutSortsSelector,
} from "./docsLayoutReducer";
export { cardsStatusSelector, cardsCardsSelector } from "./cardsReducer";
export {
    workflowStatusSelector,
    workflowProvidersSelector,
    workflowCardsSelector,
    workflowPendingCountSelector,
} from "./workflowReducer";
export {
    breadcrumbIsFavSelector,
    breadcrumbItemUriSelector,
    breadcrumbNameSelector,
    breadcrumbLevelsCountSelector,
    breadcrumbVersionSelector,
    breadcrumbFormatIdSelector,
    breadcrumbSiteTypeSelector,
    breadcrumbParentItemUriSelector,
    breadcrumbActiveSidebarItemIdSelector,
} from "./breadcrumbReducer";
export {
    currentStatusSelector,
    currentItemUriSelector,
    currentNameSelector,
} from "./currentItemReducer";
export {
    sidebarMiniSelector,
    docListViewModeSelector,
    settingValueSelector,
} from "./settingsReducer";
export {
    formDetailViewSelector,
    formLastChangeSelector,
    formAuditLogSelector,
    formGridRowIndexSelector,
    formGridRowSeqIdSelector,
    formDefaultsSelector,
    formIsEditModeSelector,
    formTabIndexSelector,
} from "./formReducer";
export {
    selectedTogglesSelector,
    togglesPersistedSelector,
} from "./togglesReducer";
export { panesViewSelector } from "./panesReducer";
export { globalSearchOptionsSelector } from "./globalSearchReducer";
export {
    searchStatusSelector,
    searchErrorSelector,
    searchResultSelector,
    searchResultTotalCountSelector,
    searchRequestSelector,
    searchTermsSelector,
    searchItemSelector,
    searchFormStatusSelector,
    searchFormChangesSelector,
    searchFormResultSelector,
    searchFormIdSelector,
    searchFormValidationSelector,
    searchCountStatusSelector,
    searchCountResultSelector,
    searchCountAggregationsSelector,
} from "./searchReducer";
export {
    searchFormListStatusSelector,
    searchFormListResultSelector,
    searchFormListCountSelector,
} from "./searchFormsReducer";
export {
    offlineSyncStatusSelector,
    offlineItemsSelector,
    offlineItemDepsMapSelector,
} from "./offlineReducer";
export { globalEventsSelector } from "./globalEventsReducer";
export {
    isOnlineSelector,
    isApiOnlineSelector,
    isNavigatorOnlineSelector,
    hasDetectedNetworkStatusSelector,
    hasBeenOnlineSelector,
} from "./networkSelectors";
export {
    isSwInitializedSelector,
    isSwFailedSelector,
    isSwUpdatedSelector,
    swRegistrationSelector,
} from "./serviceWorkerReducer";

export { notificationSelector } from "./notificationReducer";

export {
    commandActionRequestSelector,
    commandActionRequestItemSelector,
} from "./commandActionReducer";

export const itemUriSelector = (props: Object & { location: Location }) => {
    const uri = queryString.parse(props.location.search).uri;
    return uri == null
        ? null
        : `${isSpecialFolderItemUri(uri) ? "" : "pam-item://"}${uri}`;
};
